<template>
    <div class="info__input__background">
      <div class="info__input__wrapper">
        <div class="info__input__header">
          <div>아래 정보를 입력해주세요</div>
        </div>

        <div class="info__input__content">
          <div class="info__input__row">
            <div class="info__input__title">학교 및 학년</div>
            <select class="info__input" v-model.number="birth_year">
              <option :value="-1" disabled>선택</option>
              <option v-for="year in yearRange" :value="year[1]">{{ year[0] }}</option>
            </select>
          </div>
          <div class="info__input__row">
            <div class="info__input__title">성별</div>
            <select class="info__input" v-model="gender">
              <option value="M">남</option>
              <option value="F">여</option>
            </select>
          </div>
          <div class="info__input__row">
            <div class="info__input__title">소프트웨어<br/>경험여부</div>
            <select class="info__input" v-model="experience">
              <option :value="true">있음</option>
              <option :value="false">없음</option>
            </select>
          </div>
          <div class="info__input__btn" @click="saveUser" v-if="curLogin">확인</div>
          <div class="info__input__btn" @click="saveUser" v-else="curLogin">시작</div>
        </div>


        <div v-if="false" class="info__alert" :class="error === '' ? 'hidden' : ''">{{error}}</div>
      </div>
    </div>
</template>

<script>
    import { axios, was } from '@/lib/axios';

    export default {
        name: 'mapInfoInputTemplate',
        props: {
          userDevice: {
            type: String,
            default: 'pc'
          },
          courseCat: {
            type: String,
            default: '',
          },
          openCertification: {},
          showCertPopup: {},
          isTrial: {
            type: Boolean,
            default: false
          },
        },
        data() {
          return {
            grade: [
              '초등 1학년',
              '초등 2학년',
              '초등 3학년',
              '초등 4학년',
              '초등 5학년',
              '초등 6학년',
              '중등 1학년',
              '중등 2학년',
              '중등 3학년',
              '일반'
            ],
            yearRange: [],
            birth_year: -1,
            gender: 'M',
            experience: true,
            error: '',
            isLoading: false,
            publicIP:'',
            curLogin: false,
          }
        },
        watch: {
          error(error) {
            if (error !== '') setTimeout(() => {this.error = ''}, 3000)
          }
        },
        methods: {
          setCookie(obj, hours = 3) {
            try{
              let date = new Date();
              if (this.isTrial) {
                let days = 30;
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));  // Day기준
              } else {
                date.setTime(date.getTime() + (hours * 3600 * 1000));
              }

              let expires = "expires=" + date.toGMTString() +";";
              //let expires = "expires=" + date.toGMTString() +";"; // toGMTString 안되면 toUTCString 사용하여 테스틑 해볼것

              for (let key in obj) {
                // Ver1(코딩파티2018년버전)
                // document.cookie = `${key}=${obj[key]}; path=/; expires=Thur, 31 Dec 2099 23:59:59 UTC;`;  // 쿠키 만료 시간 무제한

                // Ver2(코딩파티2019년버전)
                let cookieString = `${key}=${obj[key]}; path=/; ${expires}`;
                document.cookie = cookieString;  // 쿠키 만료 시간(3시간)
                //console.log(`[Cookie] String >> ${cookieString}`);
              }
            }catch(e){
              console.log(`[Cookie] Exception : ${JSON.stringify(e)}`);
            }
          },
          saveUser() {
            if (this.birth_year === -1) {
              alert('학년을 선택해주세요.')
              return;
            }

            if (this.isLoading === true) return;
            this.isLoading = true;

            was.post(`${this.API_SERVER_URL}/manage/codmos/user/party`, {
              years: this.birth_year,
              lExp: this.experience ? 'Y' : 'N',
              sex: this.gender,
            })
            .then(res => {
              switch(res.data.code) {
                case '1000' : {
                  if (typeof res.data.trialUser === 'undefined') {
                    if (typeof res.data.trialLoginUser === 'undefined') break;
                    const loginUserInfo = JSON.parse(this.getCookie('loginUserInfo') || '{}');
                    this.setCookie({
                      loginUserInfo: JSON.stringify({
                        ...loginUserInfo,
                        birth_year: this.birth_year,
                        gender: this.gender,
                        experience: this.experience,
                        name: res.data.sessionUserName,
                      }),
                      publicIP: this.publicIP,
                    }, 9e9);
                    this.$emit('saveUser', {
                      showCertPopup: this.showCertPopup,
                    });
                  } else {
                    let obj = {
                      userType: 'party',
                      publicIP: this.publicIP,
                      isLogin: false,
                    };
                    let nonLoginUserInfo = JSON.stringify({
                      lbparty: res.data.trialUser,
                      birth_year: this.birth_year,
                      gender: this.gender,
                      experience: this.experience,
                    });
                    switch(this.courseCat) {
                      case 'ESOF01':
                        obj[`dduNonLoginUserInfo`] = nonLoginUserInfo;
                        break;
                      case 'ESOF02':
                        obj[`runNonLoginUserInfo`] = nonLoginUserInfo;
                        break;
                      case 'ESOF03':
                        obj[`jbNonLoginUserInfo`] = nonLoginUserInfo;
                        break;
                      default:
                        break;
                    };
                    this.setCookie(obj);
                    this.$emit('saveUser', {
                      openCertification: this.openCertification,
                    });
                  }
                  break;
                }
                case '2000' :
                default : {
                  console.log('실패')
                  break;
                }
              }
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              this.isLoading = false;
            })
          },
          async getClientIP() {
            return (await axios.get('https://jsonip.com')).data.ip;
          },
          scrollToModal() {
            window.parent.scrollTo({
              top: 330,
              behavior: 'smooth'
            });
          }
        },
        created() {
          const year = new Date().getFullYear()
          const startAge = 7
          const grade = this.grade.map((e, i) => [e, year - startAge - i])
          grade[grade.length - 1][1] = 1950 // 일반 선택시 연도는 강제로 1950으로 선택
          this.yearRange = grade
          this.curLogin = this.getCookie('isLogin') === 'true'
        },
        async mounted() {
          this.scrollToModal();
          try{
            // 쿠키내 PublicIP 저장여부 체크
            // PublicIP체크
            let publicIP = await this.getClientIP();
            this.publicIP = publicIP;
            //console.log(`[MapInfoInputPopup] Mounted >> PublicIP : ${this.publicIP}`);

            // 모바일 체크
            if (this.userDevice === 'mobile') {
              const RESIZE = () => {
                const WRAPPER = document.querySelector('.info__input__wrapper')

                if (Math.abs(window.orientation) === 90) {
                  WRAPPER.style.width = window.innerWidth * 0.7 + 'px'
                  WRAPPER.style.marginLeft = -(window.innerWidth * 0.7 / 2) + 'px'
                  WRAPPER.style.height = window.innerHeight * 0.9 + 'px'
                  WRAPPER.style.marginTop = -(window.innerHeight * 0.9 / 2) + 'px'
                } else {
                  WRAPPER.style.width = window.innerWidth * 0.7 + 'px'
                  WRAPPER.style.marginLeft = -(window.innerWidth * 0.7 / 2) + 'px'
                  WRAPPER.style.height = window.innerWidth * 0.7 * 1.3 + 'px'
                  WRAPPER.style.marginTop = -(window.innerWidth * 0.7 * 1.3 / 2) + 'px'
                }
              }
              RESIZE()
              window.addEventListener('resize', RESIZE)
            }
          }catch(e){
            console.log(`[MapInfoInputPopup] Err : ${e}`);
          }
        }
    }
</script>

<style lang="scss" scoped>
  .info__input__background {
    font-weight: bold;
    z-index: 3;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.55);

    > {
      .info__input__wrapper {
        background-color: white;
        z-index: 4;
        position: fixed;
        top: 50%;
        top: 330px;
        left: 50%;
        MARGIN-TOP: -235PX;
        MARGIN-LEFT: -190PX;
        overflow: hidden;
        width: 380px;
        height: 470px;
        border-radius: 20px;

        > {
          .info__input__header {
            display: inline-block;
            width: 100%;
            padding: 23px 0px;
            background-color: #58b3a1;
            color: white;
          }

          .info__input__content {
            display: inline-block;
            margin: 1%;

            > {
              .info__input__row {
                margin: 47px 0px;
              }
            }

            .info__input__title {
              text-align: left;
              display: inline-block;
              width: 150px;
            }

            .info__input {
              border: none;
              border: 1px solid #d3d3d3;
              width: 115px;
              height: 35px;
              color: #6c6c6c;
              text-align: center;
              text-align-last: center;
            }

            .info__input__btn {
              display: inline-block;
              width: 192px;
              height: 46px;
              background-color: #58b3a1;
              line-height: 46px;
              color: white;
              border-radius: 25px;
              cursor: pointer;
            }
          }

          .info__alert {
            font-weight: 100;
            right: 0px;
            bottom: 2vh;
            position:  absolute;
            background-color: #f8aaaa;
            border: 1px solid rgba(247, 51, 51, 0.5);
            box-shadow: -1px 1px 1px 1px #aaaaaa;
            border-right:  none;
            width: 9vw;
            height: 4vh;
            color: white;
            line-height: 4vh;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
            font-size: 11px;
            transition: opacity 0.15s linear;

            &.hidden {
              opacity: 0;
            }
          }
        }
      }
    }
  }

  @media only screen and (orientation:portrait){
    .mobile .info__input__background {
      * {
        font-size: 12px;
      }
      > {
        .info__input__wrapper {
          > {
            .info__input__header {
              padding: 5% 0px;
            }

            .info__input__content {
              display: inline-block;
              margin: 1%;
              width: 100%;

              > {
                .info__input__row {
                  margin: 8% 0px;
                }
              }

              .info__input__title {
                width: 25%;
              }

              .info__input {
                width: 40%;
                /*height: 20%;*/
              }

              .info__input__btn {
                width: 60%;
              }
            }

            .info__alert {
              font-weight: 100;
              right: 0px;
              bottom: 2vh;
              position:  absolute;
              background-color: #f8aaaa;
              border: 1px solid rgba(247, 51, 51, 0.5);
              box-shadow: -1px 1px 1px 1px #aaaaaa;
              border-right:  none;
              width: 9vw;
              height: 4vh;
              color: white;
              line-height: 4vh;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
              font-size: 11px;
              transition: opacity 0.15s linear;

              &.hidden {
                opacity: 0;
              }
            }
          }
        }
      }
    }
  }
  @media only screen and (orientation:landscape){
    .mobile .info__input__background {
      * {
        font-size: 12px;
      }
      > {
        .info__input__wrapper {
          > {
            .info__input__header {
              padding: 23px 0px;
            }

            .info__input__content {
              display: inline-block;
              margin: 1%;
              width: 100%;

              > {
                .info__input__row {
                  margin: 1.5% 0px;
                }
              }

              .info__input__title {
                width: 25%;
              }

              .info__input {
                width: 40%;
              }

              .info__input__btn {
                width: 60%;
              }
            }

            .info__alert {
              font-weight: 100;
              right: 0px;
              bottom: 2vh;
              position:  absolute;
              background-color: #f8aaaa;
              border: 1px solid rgba(247, 51, 51, 0.5);
              box-shadow: -1px 1px 1px 1px #aaaaaa;
              border-right:  none;
              width: 9vw;
              height: 4vh;
              color: white;
              line-height: 4vh;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
              font-size: 11px;
              transition: opacity 0.15s linear;

              &.hidden {
                opacity: 0;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/map/MapInfoInputPopup.vue